module.exports = __webpack_public_path__ + "d198656d13562bf24802079cc8b9a9f6.png";